import React, { useEffect } from 'react';
import cx from 'classnames';

import { getPromotionsCount, SiteConfigManager, useApplicationState } from '@atlas/core';

const PromotionsCounter = ({ isCustomMenuBtn = false }) => {
  const { authenticated } = useApplicationState();
  const [count, setCount] = React.useState(0);
  const showPromotionsCounter = SiteConfigManager.getConfig(
    'config.config.general.showPromotionsCounter',
  );

  useEffect(() => {
    if (!showPromotionsCounter) return;

    const timeoutId = setTimeout(() => {
      const userVisibilities = ['public', authenticated ? 'registered' : 'anonymous'];

      getPromotionsCount(userVisibilities)
        .then(({ count }) => {
          setCount(count);
        })
        .catch(() => {
          setCount(0);
        });
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [authenticated, showPromotionsCounter]);

  if (count === 0) {
    return null;
  }

  return (
    <div className={cx('menu-item-counter', { 'custom-menu-btn': isCustomMenuBtn })}>
      {count > 99 ? '99+' : count}
    </div>
  );
};

export default PromotionsCounter;
